import React from 'react';
export function Footer() {
  return <footer className="w-full bg-brown py-12 px-4" data-id="element-69">
      <div className="max-w-6xl mx-auto" data-id="element-70">
        <div className="bg-sage/10 p-6 rounded-lg mb-8" data-id="element-71">
          <p className="text-sm text-cream/80 leading-relaxed" data-id="element-72">
            <strong className="text-cream" data-id="element-73">Aviso Legal:</strong> Este libro
            tiene un propósito puramente informativo y educativo. El contenido
            aquí expuesto no constituye consejo médico, diagnóstico ni
            tratamiento profesional. Antes de iniciar cualquier programa de
            ejercicios de fuerza o cambios drásticos en su dieta, especialmente
            si padece condiciones preexistentes, es imperativo que consulte con
            su proveedor de salud. El uso de la información contenida en este
            manual es bajo su propia responsabilidad. Los resultados varían
            según la constancia y el punto de partida individual.
          </p>
        </div>

        <div className="text-center space-y-4" data-id="element-74">
          <p className="text-cream/60 text-sm" data-id="element-75">
            © 2024 Menopausia Activa. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm text-cream/60" data-id="element-76">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-77">
              Términos
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-78">
              Privacidad
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-79">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}